// File: /c:/Users/luqman/source/repos/canapps-frontend/src/containers/pages/CANpark/utils/mapTicketTypeToColor.ts

/**
 * Maps a ticket type to its corresponding color.
 * @param ticketType - The type of the ticket.
 * @returns The color associated with the ticket type.
 */
export function mapTicketTypeToColor(
	ticketType: string,
): 'secondary' | 'warning' | 'error' {
	const ticketTypeColorMap: Record<
		string,
		'secondary' | 'warning' | 'error'
	> = {
		log: 'secondary',
		logAndWarn: 'warning',
		tow: 'error',
	};

	return ticketTypeColorMap[ticketType] || '#000000'; // Default color if ticket type is not found
}
